import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { injectIntl } from "@edx/frontend-platform/i18n";
import { Icon } from "@openedx/paragon";
import { Close, MenuIcon } from "@openedx/paragon/icons";
import { useMobileResponsive, useOutsideClick } from "../utils";
import useIsSpeechCraftMFE from "../hooks/useIsSpeechcraftMFE";
import { getConfig } from "@edx/frontend-platform";
import Cookies from "universal-cookie";


function HeaderDrawer({ intl }) {
  const [toggleDrawer, setIstoggleDrawer] = useState(false);
  const isSpeechCraftMFE = useIsSpeechCraftMFE();
  const cookies = new Cookies();

  const BASE_URL = isSpeechCraftMFE
      ? getConfig().SPEECHCRAFT_MFE_BASE_URL
      : getConfig().DASHBOARD_MFE_BASE_URL;
  

  const handleLogout = () => {
      cookies.remove("csrftoken", { path: getConfig().LOGOUT_URL });
      window.location.replace(getConfig().LOGOUT_URL);
      setIstoggleDrawer(false);
    };
    
  const ref = useRef(null);
  useOutsideClick(() => {
    setIstoggleDrawer(false);
  }, ref);

  

  const handleSidebar = () => {
    setIstoggleDrawer(!toggleDrawer);
  };

  useEffect(() => {
    const [element] = document.getElementsByTagName("body");
    if (toggleDrawer) {
      element.classList.add("show-courses-sidebar");
    } else {
      element.classList.remove("show-courses-sidebar");
    }
  }, [toggleDrawer]);

  const isMobileView = useMobileResponsive(991);
  useEffect(() => {
    if (!isMobileView) {
      setIstoggleDrawer(false);
    }
  }, [isMobileView]);

  useEffect(() => {
    if (isMobileView) {
      setIstoggleDrawer(false);
    }
  }, [isMobileView]);

  return (
    <>
      <div
        className={classNames("mb-sidebar-overlay", {
          "show-overlay": toggleDrawer,
        })}
      ></div>
      <div ref={ref}>
        <div className="d-md-none w-100">
          <button
              className="reset-btn sidebar-toggle-btn"
              onClick={handleSidebar}
              aria-expanded={toggleDrawer ? "true" : "false"}
            >
              <Icon src={toggleDrawer ? Close : MenuIcon} />
          </button>
        </div>

        <div
          className={classNames("d-md-none sidebarContainer", {
            "show-mb-sidebar": toggleDrawer,
          })}
        >
          <div className="px-4 mb-3">
            <button
              aria-label="Close Sidebar"
              className="reset-btn"
              onClick={handleSidebar}
            >
              <Icon src={Close} />
            </button>
          </div>

          <ul className="sidebar-links">
            <li>
              <a href="#"
                onClick={() => {
                  window.location.assign(BASE_URL);
                }}
              >
                Learning Dashboard
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={handleLogout}
                className="dark-color"
              >
                Sign Out
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default injectIntl(HeaderDrawer);
